import React, { useEffect, useRef, useState } from 'react';
import { Form, Button, Alert } from 'react-bootstrap';
import './contactusform.scss';
import './ContactUsZenwallet.scss';
import { t, translate } from 'react-switch-lang';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// eslint-disable-next-line import/no-unresolved
import { faMobileAlt, faWindow } from '@awesome.me/kit-299dd46f46/icons/classic/regular';
import { SubmitContactUs, hideContactError } from '../../../helperFunctions/SubmitContactUs';
import { mailcheckValidate, validateBody, validateName, validateEmail } from './Validation';
import Passport from '../../../images/zenwallet/CashPassport.png';
import { setScreenReaderAlert } from '../../../helperFunctions/Accessibility';
import RadioBuilder from './RadioBuilder';
import { performSearch } from '../../../components/algolia/AlgoliaUtils';
import RelevantFAQ from './RelevantFAQ';

function ContactUsZenwallet({ widgetMode, removeAccount }) {
  const { lang } = useSelector((state) => state);

  const emailRef = useRef();
  const bodyref = useRef();
  const nameRef = useRef();

  const [appId, setAppId] = useState('');
  const [application, setApplication] = useState('');
  const [category, setCategory] = useState('');
  const cardType = 'Canada Post Cash Passport™ Prepaid Mastercard';
  const [show, setShow] = useState(false);
  const [error, setError] = useState('');
  const [disable, setDisable] = React.useState(false);

  const [webActive, setWebActive] = useState(false);
  const [mobileActive, setMobileActive] = useState(false);

  const [searchTerm, setSearchTerm] = useState('');
  const [searchResults, setSearchResults] = useState([]);
  const [suggestedArticleAlertRead, setSuggestedArticleAlertRead] = useState(false);

  const isMobile = (window.location.href.includes('mobileapp') ? '?mobileapp' : '');

  const DEFAULT_FORM_ERROR = {
    email: null,
    description: null,
    category: null,
    appId: null,
    name: null,
  };

  const [validateAppIdOnChange, setValidateAppIdOnChange] = useState(false);
  const [validateCategoryOnChange, setValidateCategoryOnChange] = useState(false);
  const [validateEmailOnChange, setValidateEmailOnChange] = useState(false);
  const [validateDescriptionOnChange, setValidateDescriptionOnChange] = useState(false);
  const [validateNameOnChange, setValidateNameOnChange] = useState(false);

  const [formError, setFormError] = useState(DEFAULT_FORM_ERROR);
  const [showEmailConfirm, setShowEmailConfirm] = useState(false);
  const [runMailCheck, setRunMailCheck] = useState(true);
  const [invalidEmailSuggestion, setInvalidEmailSuggestion] = useState(null);
  const [submitted, setSubmitted] = useState(false);

  function handleWebMobileClick(target) {
    hideContactError('app_error_message');

    const isWebsite = target === 'web';
    if (isWebsite) {
      setApplication('Web');
      setAppId('Zenwallet.ca website');
    } else {
      setApplication('Mobile');
      setAppId('Zenwallet mobile app');
    }

    setWebActive(isWebsite);
    setMobileActive(!isWebsite);
  }

  function handleSecondaryClick(target) {
    hideContactError('category_error_message');
    switch (target) {
      case 'r1':
        setCategory('Card Usage');
        break;
      case 'r2':
        setCategory('Loading Issues');
        break;
      case 'r3':
        setCategory('Other');
        break;
      case 'r4':
        setCategory('Data or account deletion request');
        break;
      default:
        break;
    }
  }

  useEffect(() => {
    if (widgetMode) {
      document.getElementById('desktop-contact-us').style.padding = '0px';
    }
    if (removeAccount) {
      handleWebMobileClick('mobile');
      handleSecondaryClick('r4');
    }
  }, []); //eslint-disable-line

  useEffect(() => {
    async function updateSearchResults() {
      const results = await performSearch(searchTerm, 'zenwallet', lang);
      if (results.length > 0) {
        setSuggestedArticleAlertRead(true);
        setScreenReaderAlert(t('FAQ_ScreenReaderAlert_Suggested_Article', null, lang));
      } else if (suggestedArticleAlertRead) {
        setScreenReaderAlert(t('FAQ_ScreenReaderAlert_No_Suggested_Article', null, lang));
      }
      setSearchResults(results);
    }
    const timer = setTimeout(updateSearchResults, 700);
    return () => { clearTimeout(timer); };
  }, [searchTerm, lang]);

  useEffect(() => {
    const blockLocation = (widgetMode ? 'center' : 'start');

    if (submitted) {
      const errorField = document.querySelector('.is-invalid');
      if (errorField) {
        const group = errorField.closest('.form-groups');
        if (group) {
          group.scrollIntoView({ behavior: 'smooth', block: blockLocation });
          const input = group.querySelector('input, textarea, select');
          setTimeout(() => {
            input?.focus();
          }, 250);
        } else {
          errorField.scrollIntoView({ behavior: 'smooth', block: blockLocation });
          errorField.focus();
        }
      }
      setSubmitted(false);
    }
  });

  function validateFormField(force) {
    const errors = { ...DEFAULT_FORM_ERROR };
    if ((validateEmailOnChange || force) && emailRef.current) {
      const { value } = emailRef.current;
      errors.email = validateEmail(value);

      if (errors.email === null) {
        setInvalidEmailSuggestion(mailcheckValidate(value));
        if (runMailCheck && invalidEmailSuggestion !== null) {
          setShowEmailConfirm(true);
          errors.email = t('Contact_EmailSuggestion').replace('xEmail', invalidEmailSuggestion);
        } else {
          setShowEmailConfirm(false);
        }
      } else {
        setShowEmailConfirm(false);
      }
    }

    if ((validateAppIdOnChange || force) && appId === '') errors.appId = t('Validation_Required');

    if ((validateCategoryOnChange || force) && category === '') errors.category = t('Validation_Required');

    if ((validateDescriptionOnChange || force) && bodyref.current) {
      const { value } = bodyref.current;
      errors.description = validateBody(value);
    }

    if ((validateNameOnChange || force) && nameRef.current) {
      const { value } = nameRef.current;
      errors.name = validateName(value);
    }

    setFormError(errors);
    return errors;
  }

  function cardUsageMessage() {
    setShow(false);
    document.getElementById('desktop-contact-us').style.visibility = 'hidden';
    document.getElementById('card-usage-message').style.visibility = 'visible';
    document.getElementById('card-usage-message').style.display = 'block';
    const focus = document.getElementById('card-usage-message');
    focus.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  function sendAPI() {
    const data = {
      Brand: 'Zenwallet',
      Application: application,
      BrandID: appId,
      CustomerEmail: emailRef.current.value,
      Language: lang,
      Category: category,
      CardType: cardType,
      Body: bodyref.current.value,
      Name: nameRef.current.value,
    };

    const sending = document.getElementById('submit-button');
    sending.innerHTML = t('ContactForm_Submitting');
    setDisable(true);

    SubmitContactUs(data).then(
      () => {
        setShow(false);
        document.getElementById('desktop-contact-us').style.visibility = 'hidden';
        document.getElementById('successMessage').style.visibility = 'visible';
        document.getElementById('successMessage').style.display = 'block';
        const focus = document.getElementById('successMessage');
        focus.scrollIntoView({ behavior: 'smooth', block: 'center' });
      },
      () => {
        setError(t('Error_Something_Went_Wrong'));
        setShow(true);
        sending.innerHTML = t('ContactForm_Submit_button');
        setDisable(false);
        const focus = document.getElementById('error_message');
        focus.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    );
  }

  function handleSubmit(e) {
    e.preventDefault();

    setValidateEmailOnChange(true);
    setValidateDescriptionOnChange(true);
    setValidateAppIdOnChange(true);
    setValidateCategoryOnChange(true);

    if (category === 'Card Usage') {
      cardUsageMessage();
      return;
    }

    const errors = validateFormField(true);
    if (!Object.values(errors).some((err) => err !== null)) {
      sendAPI();
      setScreenReaderAlert(t('ScreenReader_ContactForm_Success'));
    } else {
      setScreenReaderAlert(t('ScreenReader_ContactForm_Error'));
      setSubmitted(true);
    }
  }

  const handleTextareaChange = (e) => {
    setSearchTerm(e.target.value);
  };

  return (
    <>
      {show && (
        <Alert
          variant="danger"
          id="error_message"
          className="mt-3"
          onClose={() => {
            setShow(false);
            setError('');
          }}
          dismissible
        >
          <p style={{ marginBottom: 0 }}>{error}</p>
        </Alert>
      )}
      <div id="successMessage">
        <h1>{t('ContactForm_Submitted')}</h1>
        <Link to={(widgetMode) ? `/widget/zenwallet/${lang}${isMobile}` : `/zenwallet/${lang}/categories`}>
          <Button className="error-go-home-btn zenwallet-button">{t('ReturnHome_Btn')}</Button>
        </Link>
      </div>
      <div id="card-usage-message">
        <h1 dangerouslySetInnerHTML={{ __html: t('Zenwallet_Card_Usage_Message') }} />
        <Link to={(widgetMode) ? `/widget/zenwallet/${lang}${isMobile}` : `/zenwallet/${lang}/categories`}>
          <Button className="error-go-home-btn zenwallet-button">{t('ReturnHome_Btn')}</Button>
        </Link>
      </div>
      <div id="desktop-contact-us">
        <div id="skip-link-content">
          <h1>{t('General_Contact_Us')}</h1>
          <p className="contact-label-suggestion">{t('ContactForm_Fields_Required')}</p>
          <Form onSubmit={handleSubmit}>
            <Form.Group
              className="form-groups"
              controlId="ContactForm_General_Email_"
              required
            >
              <fieldset>
                <Form.Label as="legend" id="aria-email" className={`form-labels ${formError.appId ? 'is-invalid' : ''}`}>
                  {t('ContactForm_General_Email_Label')}
                </Form.Label>

                <Form.Text className="muted helpText">
                  {t('ContactForm_General_Email_Help')}
                </Form.Text>
                <Form.Control
                  aria-labelledby="aria-email aria-email-warn"
                  type="text"
                  ref={emailRef}
                  className={`email-attr ${formError.email ? 'is-invalid' : ''}`}
                  onBlur={() => {
                    setValidateEmailOnChange(true);
                    validateFormField();
                  }}
                  onChange={() => {
                    if (validateEmailOnChange) validateFormField();
                    setRunMailCheck(true);
                  }}
                />
                {formError.email && (
                  <span className="errorMessage">{formError.email}</span>
                )}
                <div className="invalidEmailContainer">
                  {showEmailConfirm && (
                    <div className="zenwallet-web-mobile">
                      <Button
                        text={t('AccountDetails_MailCheck_ButtonYes')}
                        fill="outline"
                        className="mailCheckButton clickable-btn"
                        aria-label={t('Contact_EmailSuggestionYes').replace('xEmail', invalidEmailSuggestion)}
                        onClick={() => {
                          setRunMailCheck(false);
                          emailRef.current.value = invalidEmailSuggestion;
                          formError.email = null;
                          setInvalidEmailSuggestion(null);
                          setShowEmailConfirm(false);
                        }}
                      >
                        {t('Yes_Text')}
                      </Button>
                      <Button
                        text={t('AccountDetails_MailCheck_ButtonNo')}
                        fill="outline"
                        className="mailCheckButton clickable-btn"
                        aria-label={t('Contact_EmailSuggestionNo')}
                        onClick={() => {
                          setShowEmailConfirm(false);
                          setRunMailCheck(false);
                          formError.email = null;
                        }}
                      >
                        {t('No_Text')}
                      </Button>
                    </div>
                  )}
                </div>
              </fieldset>
            </Form.Group>

            <Form.Group
              className="form-inline"
              controlId="ContactForm_AppID_"
              required
            >
              <fieldset className="zenwallet-radio">
                <Form.Label as="legend" id="app_label" className="form-labels">
                  {t('ContactForm_General_AppID_Label')}
                </Form.Label>
                <div className="radio-container">
                  <RadioBuilder
                    value="mobile"
                    group="webmobile"
                    selected={mobileActive}
                    clickHandler={() => handleWebMobileClick('mobile')}
                    content={(
                      <>
                        <FontAwesomeIcon icon={faMobileAlt} className="btn-icon" />
                        {t('ContactForm_AppID_Mobile')}
                      </>
                    )}
                  />
                  <RadioBuilder
                    value="web"
                    group="webmobile"
                    selected={webActive}
                    clickHandler={() => handleWebMobileClick('web')}
                    content={(
                      <>
                        <FontAwesomeIcon icon={faWindow} className="btn-icon" />
                        {t('ContactForm_AppID_Website')}
                      </>
                    )}
                  />
                </div>
                {formError.appId && (
                  <span className="errorMessage errorMessageBlock " id="app_error_message">{formError.appId}</span>
                )}
              </fieldset>
            </Form.Group>

            {/* What do you need help with? */}
            <fieldset className="zenwallet-radio form-group">
              <Form.Label as="legend" id="category_label" className="form-labels">
                {t('ContactForm_General_Category_Label')}
              </Form.Label>
              <RadioBuilder
                content={(
                  <>
                    {' '}
                    {t('ContactForm_Category_Zenwallet_CardServices')}
                    <div style={{ fontSize: 'smaller' }}>
                      {t('ContactForm_Category_Zenwallet_CardServices_Deets')}
                    </div>
                  </>
                )}
                clickHandler={handleSecondaryClick}
                value="r1"
                group="radio"
              />
              <RadioBuilder content={t('ContactForm_Category_Zenwallet_LoadIssue')} clickHandler={handleSecondaryClick} value="r2" group="radio" fixAlignment />
              <RadioBuilder content={t('ContactForm_Category_All_AccountDeletion')} clickHandler={handleSecondaryClick} value="r4" group="radio" selected={removeAccount} fixAlignment />
              <RadioBuilder content={t('ContactForm_Category_General_Other')} clickHandler={handleSecondaryClick} value="r3" group="radio" />
              {formError.category && (
                <span className="errorMessage" id="category_error_message">{formError.category}</span>
              )}
            </fieldset>

            {/* Which card do you need help with? */}
            <fieldset className="zenwallet-radio form-group">

              <Form.Label
                as="legend"
                id="cardtype_label"
                className="form-labels"
              >
                {t('ContactForm_General_CardType_Label')}
              </Form.Label>

              <RadioBuilder
                value="c1"
                content={(
                  <>
                    <img
                      className="card_images"
                      src={Passport}
                      alt={t('ContactForm_ProductType_Zenwallet_CashPassport')}
                    />
                    {t('ContactForm_ProductType_Zenwallet_CashPassport')}
                  </>
                )}
                group="card"
                selected
              />

              <Form.Text
                id="cardtype_error_message"
                className="error-handling-messages"
              >
                {t('Validation_Required')}
              </Form.Text>
            </fieldset>

            {/* Name field */}
            <Form.Group className="form-groups" controlId="ContactForm_General_Name_" required>
              <Form.Label as="legend" id="name" className="form-labels">
                {t('ContactForm_Name')}
              </Form.Label>
              <Form.Control
                aria-labelledby="name"
                ref={nameRef}
                className={formError.name ? 'is-invalid' : ''}
                onBlur={() => {
                  setValidateNameOnChange(true);
                  validateFormField();
                }}
                onChange={() => {
                  if (validateNameOnChange) validateFormField();
                  setValidateNameOnChange(true);
                }}
              />
              {formError.name && (
                <span className="errorMessage">{formError.name}</span>
              )}
            </Form.Group>

            {/* Description textbox field */}
            <Form.Group
              className="form-groups"
              controlId="ContactForm_General_Body_"
              required
            >
              <fieldset>
                <Form.Label as="legend" id="aria-desc" className="form-labels">
                  {t('ContactForm_General_Body_Label')}
                </Form.Label>

                <Form.Control
                  aria-labelledby="aria-desc"
                  as="textarea"
                  rows={8}
                  ref={bodyref}
                  className={`description-attr ${formError.description ? 'is-invalid' : ''}`}
                  onBlur={() => {
                    setValidateDescriptionOnChange(true);
                  }}
                  onChange={(e) => {
                    handleTextareaChange(e);
                    if (validateDescriptionOnChange) validateFormField();
                  }}
                />
                {formError.description && (
                  <span className="errorMessage">{formError.description}</span>
                )}
              </fieldset>
            </Form.Group>
            <RelevantFAQ searchResults={searchResults} brand="zenwallet" lang={lang} />

            <Button
              id="submit-button"
              className="zenwallet-button"
              type="submit"
              disabled={disable}
              size="lg"
              style={{ backgroundColor: '#2B4E7B' }}
            >
              {t('ContactForm_Submit_button')}
            </Button>
          </Form>
          <Alert className="mt-3 email-banner" show={process.env.REACT_APP_ENV === 'dev'}>
            On the test system, contact form emails will be sent to
            <strong> psidevstar@gmail.com</strong>
          </Alert>
        </div>
      </div>
    </>
  );
}

export default translate(ContactUsZenwallet);
